import HeadlineField, { HeadlineTag } from '@/storyblok/wirfuersklima/functionalComponents/HeadlineField';
import { nl2br } from '@/storyblok/wirfuersklima/helper/utils';

export interface BoxedHeadlineProps {
  headline: string;
  tag: HeadlineTag;
  style?: HeadlineTag;
}

const BoxedHeadline: React.FC<BoxedHeadlineProps> = (props) => {
  return (
    <HeadlineField tag={props.tag} style={props.style} className="boxed-headline">
      {props.headline.split(/\r?\n/).map((line) => (
        // Legacy campaign: line breaks from CMS; content is plain text + nl2br only.
        // eslint-disable-next-line react/no-danger -- controlled nl2br output from Storyblok string
        <span key={line} dangerouslySetInnerHTML={{ __html: nl2br(line, true, true) }} />
      ))}
    </HeadlineField>
  );
};

export default BoxedHeadline;
